<ng-container *ngTemplateOutlet="alertsTmpl"></ng-container>

<div class="rfq-body-content rfq-body-content--full-height">
  <ng-container *ngTemplateOutlet="ctrlPanelTmpl"></ng-container>
  <ng-container *ngTemplateOutlet="mainBodyTmpl"></ng-container>
</div>

<!-- END OF MAIN CONTENT -->

<!-- CONTROL PANEL -------------------------------------------------->
<ng-template #ctrlPanelTmpl>
  <div class="control-panel" *ngIf="isOwner && !isComplete">
    <div class="pricing-btns" *ngIf="!isVolBased">
      <div
        *ngIf="priceStreamingState === 'UNAVAILABLE'"
        class="pricing-unavailable"
      >
        <div class="pricing-unavailable__top">Pricing unavailable</div>
        <div class="pricing-unavailable__bottom">Reopen quote to retry</div>
      </div>
      <ng-container *ngIf="priceStreamingState !== 'UNAVAILABLE'">
        <button
          class="ui-button ui-button--primary"
          *ngIf="priceStreamingState === 'STREAMING' && showStreamingButton"
          (click)="setPriceStreamingState('MANUAL')"
        >
          <span class="button-text">
            Streaming<ng-container
              *ngTemplateOutlet="ellipsisTmpl"
            ></ng-container>
          </span>
        </button>
        <button
          class="ui-button ui-button--primary"
          *ngIf="priceStreamingState === 'MANUAL'"
          (click)="setPriceStreamingState('STREAMING')"
        >
          <span class="button-text"> Manual </span>
        </button>
        <button
          class="ui-button ui-button--primary"
          [disabled]="priceStreamingState !== 'MANUAL'"
          (click)="priceManual()"
        >
          <span class="button-text"> Refresh </span>
        </button>
      </ng-container>
    </div>
    <div class="quote-accept-btns">
      <ng-container *ngIf="canQuote">
        <button
          class="ui-button ui-button--success"
          (click)="doQuote()"
          [disabled]="quoteButtonDisabled()"
          [@pulseQuoteButton]="expiresIn < 0 && canQuote"
        >
          <span class="button-text">
            <ng-container *ngIf="!quoteInFlight">
              <ng-container [ngSwitch]="quoteSubmit().quoteSubmitStatus">
                <ng-container *ngSwitchCase="'INITIAL'"> Quote </ng-container>
                <ng-container *ngSwitchCase="'ERROR'">
                  Quote Error
                </ng-container>
                <ng-container *ngSwitchCase="'SUBMITTING'">
                  Submitting
                  <ng-container *ngTemplateOutlet="ellipsisTmpl"></ng-container>
                </ng-container>
                <ng-container *ngSwitchDefault> Quote </ng-container>
              </ng-container>
            </ng-container>
            <ng-container *ngIf="quoteInFlight"> Update quote </ng-container>
          </span>
        </button>
      </ng-container>

      <button
        class="ui-button ui-button--success"
        *ngIf="canAccept"
        [disabled]="accepting"
        (click)="doAccept()"
      >
        <span class="button-text" *ngIf="!accepting"> Accept </span>
        <span class="button-text" *ngIf="accepting"> Accepting... </span>
      </button>
    </div>

    <div class="release-decline-btns">
      <ng-container *ngIf="!isComplete">
        <button
          class="ui-button ui-button--warning"
          (click)="doWithdraw()"
          *ngIf="canWithdraw"
        >
          <span class="button-text"> Withdraw </span>
        </button>

        <button
          class="ui-button ui-button--warning"
          (click)="doRelease()"
          *ngIf="canRelease"
        >
          <span class="button-text"> Release </span>
        </button>

        <button
          class="ui-button ui-button--warning"
          [disabled]="true"
          *ngIf="!(canRelease || canWithdraw)"
        >
          <span class="button-text"> Release </span>
        </button>

        <button
          class="ui-button ui-button--danger"
          (click)="doDeclineRFQ()"
          *ngIf="canDeclineRFQ"
        >
          <span class="button-text"> Decline</span>
        </button>

        <button
          class="ui-button ui-button--danger"
          (click)="doDeclineRFE()"
          *ngIf="canDeclineRFE"
        >
          <span class="button-text"> Decline </span>
        </button>
        <button
          class="ui-button ui-button--danger"
          *ngIf="!(canDeclineRFE || canDeclineRFQ)"
          [disabled]="true"
        >
          <span class="button-text"> Decline </span>
        </button>
      </ng-container>
    </div>
  </div>
</ng-template>

<!-- MAIN BODY -------------------------------------------------->
<ng-template #mainBodyTmpl>
  <div class="main-body">
    <div class="table-divider"></div>
    <div *ngIf="canQuote">
      <ng-container *ngTemplateOutlet="formTmpl"></ng-container>
      <ng-container
        *ngIf="
          activeQuote ||
          (isWhiteLabel &&
            (
              allQuotes
              | quoteFilterByProvider: bankToFilter : true
              | quoteTimeLimitFilter: currentTimestamp
            ).length)
        "
      >
        <ng-container
          *ngTemplateOutlet="
            activeQuoteTmpl;
            context: {
              thequote: activeQuote,
              whiteLabelMode: isWhiteLabel && !activeQuote
            }
          "
        ></ng-container>
      </ng-container>
      <ng-container *ngIf="executionType === 'volBased' && currentClientPrice">
        <ng-container
          *ngTemplateOutlet="clientPriceTmpl; context: { done: false }"
        ></ng-container>
      </ng-container>
      <ng-container
        *ngTemplateOutlet="
          quotesTmpl;
          context: {
            isFrozen: isTraded
          }
        "
      ></ng-container>
      <ng-container *ngTemplateOutlet="risksTmpl"></ng-container>
    </div>
    <div *ngIf="isTraded || canAccept">
      <ng-container *ngIf="canAccept">
        <ng-container *ngTemplateOutlet="formTmpl"></ng-container>
      </ng-container>
      <ng-container
        *ngTemplateOutlet="
          activeQuoteTmpl;
          context: { thequote: quoteEvent.quote }
        "
      ></ng-container>
      <ng-container *ngIf="executionType === 'volBased' && currentClientPrice">
        <ng-container
          *ngTemplateOutlet="clientPriceTmpl; context: { done: true }"
        ></ng-container>
      </ng-container>
      <ng-container
        *ngTemplateOutlet="
          quotesTmpl;
          context: {
            isFrozen: isTraded
          }
        "
      ></ng-container>
      <ng-container *ngTemplateOutlet="risksTmpl"></ng-container>
    </div>
  </div>
</ng-template>

<!-- FORM -------------------------------------------------->
<ng-template #formTmpl>
  <form [formGroup]="form" autocomplete="off" *ngIf="!isVolBased">
    <ng-container *ngIf="pricesLoading">
      <div class="loading loading-text" *ngIf="initialPrice">
        Loading current price
      </div>
      <div class="loading loading-text" *ngIf="!initialPrice">
        Updating price
      </div>
      <loading-spinner class="loading" [size]="'80px'"></loading-spinner>
    </ng-container>
    <ng-container *ngIf="!initialPrice">
      <div class="pricegrid">
        <ng-container
          *ngTemplateOutlet="clientActionsHeadersTmpl"
        ></ng-container>

        <div class="hline hline__top"></div>
        <ng-container *ngIf="showDvIndic">
          <ng-container *ngTemplateOutlet="dvIndicTmpl"></ng-container>
        </ng-container>
        <ng-container *ngFor="let v of legInfo; let i = index">
          <ng-container
            *ngTemplateOutlet="volsTmpl; context: { index: i }"
          ></ng-container>
        </ng-container>
        <ng-container *ngIf="showMargin">
          <ng-container *ngTemplateOutlet="marginTmpl"></ng-container>
        </ng-container>
        <ng-container *ngIf="isVolBased">
          <ng-container *ngTemplateOutlet="hedgeTmpl"></ng-container>
          <ng-container *ngTemplateOutlet="hedgeRateTmpl"></ng-container
        ></ng-container>
        <ng-container *ngIf="showVendorPrice">
          <ng-container *ngTemplateOutlet="vendorTmpl"></ng-container>
        </ng-container>
        <div class="hline hline__bottom"></div>
      </div>
    </ng-container>
    <!-- VENDOR PRICE -------------------------------------------------->
    <ng-template #vendorTmpl>
      <div class="vendorlabel">
        {{ quoteEvent.quote?.providerShortName }} Price
      </div>

      <ng-container>
        <label class="cash-premium-bid-label">{{
          cashPremiumInfo.label.bid
        }}</label>

        <clr-input-container class="cash-premium-bid">
          <input
            clrInput
            type="text"
            [ngClass]="{
              'manual-input': !cashPremiumInfo.liveValue.bid,
              disabled: form.get('cashPremiumBid').disabled
            }"
            [@.disabled]="!cashPremiumInfo.liveValue.bid"
            [@valueIncreaseDecrease]="
              cashPremiumInfo.latestValue.bid | cleanFormattedNumeric
            "
            [inputValidator]="['negativeNumericShorthand']"
            formControlName="cashPremiumBid"
            (input)="changeInCashPremium('bid', $any($event.target).value)"
            (blur)="blurCashPremium('bid', $any($event.target).value)"
        /></clr-input-container>

        <div class="cash-premium-bid-CCY">
          {{ premiumCCY }}
        </div>
      </ng-container>

      <ng-container>
        <label class="cash-premium-offer-label">{{
          cashPremiumInfo.label.offer
        }}</label>
        <clr-input-container class="cash-premium-offer">
          <input
            clrInput
            type="text"
            [ngClass]="{
              'manual-input': !cashPremiumInfo.liveValue.offer,
              disabled: form.get('cashPremiumOffer').disabled
            }"
            [@.disabled]="!cashPremiumInfo.liveValue.offer"
            [@valueIncreaseDecrease]="
              cashPremiumInfo.latestValue.offer | cleanFormattedNumeric
            "
            [inputValidator]="['negativeNumericShorthand']"
            formControlName="cashPremiumOffer"
            (input)="changeInCashPremium('offer', $any($event.target).value)"
            (blur)="blurCashPremium('offer', $any($event.target).value)"
        /></clr-input-container>

        <div class="cash-premium-offer-CCY">
          {{ premiumCCY }}
        </div>
      </ng-container>

      <!-- Premium in style -->
      <ng-container *ngTemplateOutlet="premiumInStyle"></ng-container>
    </ng-template>

    <!-- HEDGE RATE -------------------------------------------------->
    <ng-template #hedgeRateTmpl>
      <ng-container *ngIf="hedge">
        <div class="hedgeratelabel">Hedge Rate</div>
        <div class="hedgeratebid">
          <div></div>
          <clr-input-container
            class="hedgeRate"
            [@quotePulse]="formValue('hedgeRateBid') | safeNumber: '1.4-4'"
          >
            <input
              clrInput
              type="text"
              [inputValidator]="'positiveNumber'"
              [required]="!!hedge"
              formControlName="hedgeRateBid"
              [readOnly]="isCustomHedgeRate"
              (blur)="syncSides()"
            />
          </clr-input-container>
        </div>
        <div class="hedgerateoffer">
          <div></div>
          <clr-input-container
            class="hedgeRate"
            [@quotePulse]="formValue('hedgeRateOffer') | safeNumber: '1.4-4'"
          >
            <input
              clrInput
              type="text"
              [inputValidator]="'positiveNumber'"
              [required]="!!hedge"
              formControlName="hedgeRateOffer"
              [readOnly]="isCustomHedgeRate"
              (blur)="syncSides()"
            />
          </clr-input-container>
        </div>
      </ng-container>
    </ng-template>

    <!-- HEDGE AMOUNT -------------------------------------------------->
    <ng-template #hedgeTmpl>
      <ng-container *ngIf="hedge">
        <div class="hedgelabel">Hedge Amount</div>
        <div class="hedgebid">
          <select clrSelect formControlName="hedgeBidOption" [tabIndex]="-1">
            <option value="clientSells">Client Sells</option>
            <option value="clientBuys">Client Buys</option>
          </select>
          <clr-input-container
            [@quotePulse]="formValue('hedgeBid') | safeNumber: '1.0-0'"
          >
            <input
              clrInput
              type="text"
              [inputValidator]="'numericShorthand'"
              [required]="!!hedge"
              formControlName="hedgeBid"
              (blur)="syncSides()"
            />
          </clr-input-container>
          <div class="ccy">{{ baseCCY }}</div>
        </div>
        <div class="hedgeoffer">
          <select clrSelect formControlName="hedgeOfferOption" [tabIndex]="-1">
            <option value="clientSells">Client Sells</option>
            <option value="clientBuys">Client Buys</option>
          </select>
          <clr-input-container
            [@quotePulse]="formValue('hedgeOffer') | safeNumber: '1.0-0'"
          >
            <input
              clrInput
              type="text"
              [inputValidator]="'numericShorthand'"
              [required]="!!hedge"
              formControlName="hedgeOffer"
              (blur)="syncSides()"
            />
          </clr-input-container>
          <div class="ccy">{{ baseCCY }}</div>
        </div>
      </ng-container>
    </ng-template>

    <!-- MARGINS -------------------------------------------------->
    <ng-template #marginTmpl>
      <div class="marginlabel">Margin</div>
      <div class="marginbid">
        <div></div>
        <clr-input-container
          [@quotePulse]="formValue('marginBid') | safeNumber: '1.4-4'"
        >
          <input
            clrInput
            type="text"
            [inputValidator]="'numericShorthand'"
            [required]="true"
            formControlName="marginBid"
            (blur)="syncSides()"
          />
        </clr-input-container>
        <div class="premiumCCY">{{ premiumCCY }}</div>
      </div>
      <div class="marginoffer">
        <div></div>
        <clr-input-container
          [@quotePulse]="formValue('marginOffer') | safeNumber: '1.4-4'"
        >
          <input
            clrInput
            type="text"
            [inputValidator]="'numericShorthand'"
            [required]="true"
            formControlName="marginOffer"
            (blur)="syncSides()"
          />
        </clr-input-container>
        <div class="premiumCCY">{{ premiumCCY }}</div>
      </div>
    </ng-template>

    <!-- VOLS -------------------------------------------------->
    <ng-template #volsTmpl let-index="index">
      <ng-container *ngIf="hasVols">
        <div class="vollable {{ 'vollabel-' + index }}">
          Volatility (Leg {{ index + 1 }})
        </div>
        <div class="{{ 'volbid-' + index + '-space' }}"></div>
        <clr-input-container
          class="{{ 'volbid-' + index + '-value' }}"
          [@quotePulse]="formArrayValue('volBid', index) | safeNumber: '1.4-4'"
          formArrayName="volBid"
        >
          <input
            class="vol-bid-input"
            clrInput
            type="text"
            [inputValidator]="'positiveNumber'"
            [required]="legInfo[index].isSingleVolProduct"
            [formControlName]="index"
            [ngClass]="{ inverted: !!legInfo[index].inverted }"
          />
        </clr-input-container>
        <div class="ccy {{ 'volbid-' + index + '-ccy' }}">%</div>
        <div class="{{ 'voloffer-' + index + '-space' }}"></div>
        <clr-input-container
          class="{{ 'voloffer-' + index + '-value' }}"
          [@quotePulse]="
            formArrayValue('volOffer', index) | safeNumber: '1.4-4'
          "
          formArrayName="volOffer"
        >
          <input
            class="vol-offer-input"
            clrInput
            type="text"
            [inputValidator]="'positiveNumber'"
            [required]="legInfo[index].isSingleVolProduct"
            [formControlName]="index"
            [ngClass]="{ inverted: !!legInfo[index].inverted }"
          />
        </clr-input-container>
        <div class="ccy {{ 'voloffer-' + index + '-ccy' }}">%</div>
      </ng-container>
    </ng-template>

    <!-- Client Header -------------------------------------------------->

    <ng-template #clientActionsHeadersTmpl>
      <div class="client-bid-header">
        {{ clientActionsHeaders.bid }}
      </div>
      <div class="current-spot" *ngIf="showSpotRate">
        {{ spotRate | safeNumber: '1.4-4' }}
        <ng-container *ngIf="timeSincePrice > 5">
          (more than 5s ago)
        </ng-container>
      </div>
      <div class="client-offer-header">
        {{ clientActionsHeaders.offer }}
      </div>
    </ng-template>

    <!-- DV INDIC -------------------------------------------------->
    <ng-template #dvIndicTmpl>
      <div class="dvlabel">DV indic.</div>
      <div
        class="bid"
        *ngIf="formValue('premiumAmountBid') | safeNumber: '1.2-2' as value"
      >
        <label *ngIf="formValue('bidOption') as option">
          <ng-container *ngIf="option === 'clientReceives'">
            Client Rcvs
          </ng-container>
          <ng-container *ngIf="option === 'clientPays'">
            Client Pays
          </ng-container>
        </label>
        <clr-input-container [@quotePulse]="value">
          <input
            clrInput
            type="text"
            [value]="value"
            [disabled]="true"
            class="disabled"
          />
        </clr-input-container>
        <div class="ccy">{{ premiumCCY }}</div>
      </div>
      <div
        class="offer"
        *ngIf="formValue('premiumAmountOffer') | safeNumber: '1.2-2' as value"
      >
        <label *ngIf="formValue('offerOption') as option">
          <ng-container *ngIf="option === 'clientReceives'">
            Client Rcvs
          </ng-container>
          <ng-container *ngIf="option === 'clientPays'">
            Client Pays
          </ng-container>
        </label>
        <clr-input-container [@quotePulse]="value">
          <input
            clrInput
            type="text"
            [value]="value"
            [disabled]="true"
            class="disabled"
          />
        </clr-input-container>

        <div class="ccy">{{ premiumCCY }}</div>
      </div>
    </ng-template>
  </form>
</ng-template>

<!-- CLIENT PRICE -------------------------------------------------->
<ng-template #clientPriceTmpl let-done="done">
  <div class="active-quote">
    <h4 *ngIf="done">Sales Quoted</h4>
    <h4 *ngIf="!done">
      Sales Quoting
      <ng-container *ngTemplateOutlet="ellipsisTmpl"></ng-container>
    </h4>
    <div class="clientpricegrid">
      <div class="left">
        {{ currentClientPrice.premium.bidType }}
        {{ currentClientPrice.premiumCurrency }}
        {{
          formatPremium(
            currentClientPrice.premium.bid,
            currentClientPrice.premiumStyle
          )
        }}
      </div>
      <div class="right">
        {{ currentClientPrice.premium.askType }}
        {{ currentClientPrice.premiumCurrency }}
        {{
          formatPremium(
            currentClientPrice.premium.ask,
            currentClientPrice.premiumStyle
          )
        }}
      </div>
    </div>
  </div>
</ng-template>

<!-- ACTIVE QUOTE -------------------------------------------------->
<ng-template
  #activeQuoteTmpl
  let-thequote="thequote"
  let-whiteLabelMode="whiteLabelMode"
>
  <div class="active-quote">
    <h4 *ngIf="!isTraded && (quoteSubmit().firstSuccess || isWhiteLabel)">
      @if (whiteLabelMode) {
        WL Engine
      }
      Currently Quoting
      <ng-container *ngTemplateOutlet="ellipsisTmpl"></ng-container>
    </h4>
    <h4 *ngIf="isTraded" @quotePulse>
      <cds-icon shape="check"></cds-icon>
      <ng-container *ngIf="quoteStatus !== 'DealtAway'">
        Trade Done
      </ng-container>
      <span *ngIf="quoteStatus === 'DealtAway'" class="dealt-away">
        Dealt Away
      </span>
    </h4>
    @if (!whiteLabelMode) {
      <div class="pricegrid" [@quotePulse]="(isTraded || canAccept) && action">
        <!-- Volatility -->
        <ng-container *ngFor="let leg of thequote?.legs; let i = index">
          <ng-container *ngIf="!!thequote?.legs[i].volatilityBid">
            <div class="vollabel vollabel-{{ i }}">
              Volatility (Leg {{ i + 1 }})
            </div>
            <div
              class="red {{ 'volbid-' + i + '-space' }} {{ action || '' }}"
            ></div>
            <div
              class="red {{ 'volbid-' + i + '-value' }} {{ action || '' }}"
              [ngClass]="{
                traded:
                  legPositions[i] !== getTradeDirection() &&
                  getTradeDirection() !== 'Unknown'
              }"
            >
              {{ thequote?.legs[i].volatilityBid * 100 | safeNumber: '1.4-4' }}
            </div>
            <div class="ccy {{ 'volbid-' + i + '-ccy' }}">%</div>
            <div
              class="green {{ 'voloffer-' + i + '-space' }} {{ action || '' }}"
            ></div>
            <div
              class="green {{ 'voloffer-' + i + '-value' }} {{ action || '' }}"
              [ngClass]="{
                traded: legPositions[i] === getTradeDirection()
              }"
            >
              {{
                thequote?.legs[i].volatilityOffer * 100 | safeNumber: '1.4-4'
              }}
            </div>
            <div class="ccy {{ 'voloffer-' + i + '-ccy' }}">%</div>
          </ng-container>
        </ng-container>

        <!-- top borders -->
        <div class="topborderbid {{ bidActiveClass }}">
          <span></span><span></span><span></span>
        </div>
        <div class="topborderoffer {{ offerActiveClass }}">
          <span></span><span></span><span></span>
        </div>

        <!-- hedge amount & rate (2 rows)-->
        <ng-container *ngIf="thequote?.hedgeBid != null">
          <div class="hedgelabel">Hedge Amount</div>
          <div class="hedgebid {{ bidActiveClass }}">
            <span>{{ currentlyQuotingClientPos?.bid }}</span>
            <span> {{ thequote?.hedgeBid | abs | safeNumber: '1.0-0' }}</span>
            <span class="ccy">{{ baseCCY }}</span>
            <span>&#64;{{ thequote?.hedgeRateBid | safeNumber: '1.4-4' }}</span>
          </div>
          <div class="hedgeoffer  {{ offerActiveClass }}">
            <span>{{ currentlyQuotingClientPos?.offer }}</span>
            <span>{{ thequote?.hedgeOffer | abs | safeNumber: '1.0-0' }}</span>
            <span class="ccy">{{ baseCCY }}</span>
            <span
              >&#64;{{ thequote?.hedgeRateOffer | safeNumber: '1.4-4' }}</span
            >
          </div>
        </ng-container>

        <!-- vendor price -->
        <ng-container *ngIf="showVendorPrice">
          <div class="vendorlabel">{{ thequote?.providerShortName }} Price</div>
          <label class="cash-premium-bid-label {{ bidActiveClass }}">
            <ng-container *ngIf="thequote.premiumAmountBid >= 0"
              >Client Rcvs</ng-container
            >
            <ng-container *ngIf="thequote.premiumAmountBid < 0"
              >Client Pays</ng-container
            >
          </label>

          <div
            class="cash-premium-bid  cash-premium-bid--currently-quoting {{
              bidActiveClass
            }}"
          >
            {{ thequote.premiumAmountBid | abs | safeNumber: '1.2-2' }}
          </div>
          <div class="ccy cash-premium-bid-CCY {{ bidActiveClass }}">
            {{ premiumCCY }}
          </div>
          <label class="cash-premium-offer-label {{ offerActiveClass }}">
            <ng-container *ngIf="thequote.premiumAmountOffer >= 0"
              >Client Pays</ng-container
            >
            <ng-container *ngIf="thequote.premiumAmountOffer < 0"
              >Client Rcvs</ng-container
            >
          </label>
          <div
            class="cash-premium-offer cash-premium-offer--currently-quoting {{
              offerActiveClass
            }}"
          >
            {{ thequote.premiumAmountOffer | abs | safeNumber: '1.2-2' }}
          </div>
          <div class="ccy cash-premium-offer-CCY {{ offerActiveClass }}">
            {{ premiumCCY }}
          </div>
        </ng-container>

        <!-- Premium in style -->
        <ng-container
          *ngTemplateOutlet="CurrentlyQuotingPremiumInStyle"
        ></ng-container>

        <!-- bottom borders -->
        <div class="bottomborderbid {{ bidActiveClass }}">
          <span></span><span></span><span></span>
        </div>
        <div class="bottomborderoffer {{ offerActiveClass }}">
          <span></span><span></span><span></span>
        </div>

        <!-- implied margin -->
        <ng-container
          *ngIf="(canAccept || canQuote || isTraded) && showImpliedMargin"
        >
          <div class="impliedmarginlabel">Implied Margin</div>
          <ng-container *ngIf="formValue('marginBid') as margin">
            <div
              class="impliedmarginbid"
              [ngClass]="{
                red: impliedMarginBid < 0,
                orange: impliedMarginOffer < +margin,
                green: impliedMarginOffer >= +margin
              }"
            >
              {{ impliedMarginBid | safeNumber: '1.2-2' }} {{ premiumCCY }}
            </div>
          </ng-container>
          <ng-container *ngIf="formValue('marginOffer') as margin">
            <div
              class="impliedmarginoffer"
              [ngClass]="{
                red: impliedMarginOffer < 0,
                orange: impliedMarginOffer < +margin,
                green: impliedMarginOffer >= +margin
              }"
            >
              {{ impliedMarginOffer | safeNumber: '1.2-2' }} {{ premiumCCY }}
            </div>
          </ng-container>
        </ng-container>
      </div>
    } @else {
      <div class="rfq-quotes">
        <ng-container
          *ngTemplateOutlet="
            twoWayQuotes;
            context: {
              isFrozen: isTraded,
              includedIn: true
            }
          "
        ></ng-container>
      </div>
    }
  </div>
</ng-template>

<ng-template #quotesTmpl let-isFrozen="isFrozen">
  <div
    class="rfq-quotes"
    *ngIf="
      !isVolBased && (allQuotes | quoteTimeLimitFilter: currentTimestamp).length
    "
  >
    <ng-container
      *ngTemplateOutlet="
        twoWayQuotes;
        context: {
          isFrozen: isFrozen,
          includedIn: false
        }
      "
    ></ng-container>
  </div>
</ng-template>

<ng-template #twoWayQuotes let-includedIn="includedIn" let-isFrozen="isFrozen">
  <div class="rfq-quotes__table-col-container">
    <ng-container
      *ngTemplateOutlet="
        sideQuotesTmpl;
        context: {
          side: 'bid',
          position: 'left',
          rows: quotes.bids,
          isFrozen: isFrozen,
          includedIn: includedIn
        }
      "
    ></ng-container>
  </div>
  <div class="rfq-quotes__quotes-divider"></div>
  <div class="rfq-quotes__table-col-container">
    <ng-container
      *ngTemplateOutlet="
        sideQuotesTmpl;
        context: {
          side: 'offer',
          position: 'right',
          rows: quotes.offers,
          isFrozen: isFrozen,
          includedIn: includedIn
        }
      "
    ></ng-container>
  </div>
</ng-template>

<!-- SIDE QUOTES-->
<ng-template
  #sideQuotesTmpl
  let-side="side"
  let-position="position"
  let-rows="rows"
  let-isFrozen="isFrozen"
  let-includedIn="includedIn"
>
  <ng-container
    *ngFor="
      let row of rows
        | quoteFilterByProvider: bankToFilter : includedIn
        | quoteTimeLimitFilter: currentTimestamp;
      index as i
    "
  >
    <ng-container
      *ngTemplateOutlet="
        quoteTmpl;
        context: {
          side: side,
          position: position,
          index: i,
          row: row,
          isFrozen: isFrozen
        }
      "
    ></ng-container>
  </ng-container>
</ng-template>

<!-- QUOTES -->

<ng-template
  #quoteTmpl
  let-side="side"
  let-position="position"
  let-index="index"
  let-row="row"
  let-isFrozen="isFrozen"
>
  <app-rfq-quote
    [row]="row"
    [index]="index"
    [position]="position"
    [side]="side"
    [currentTimestamp]="currentTimestamp"
    [showInlineVol]="showInlineVol"
    [showBank]="true"
    [rfqRunning]="true"
    [hedge]="hedge"
    [forwardPointsMultiplier]="forwardPointsMultiplier"
    [cross]="ccyPair"
    [termPair]="termPair"
    [baseCurrency]="baseCCY"
    [disabled]="true"
    [animateQuotes]="false"
    [frozenQuote]="isFrozen"
    [pipsHighlightedIndices]="pipsHighlightedIndices"
  ></app-rfq-quote>
</ng-template>

<!-- RISKS -->
<ng-template #risksTmpl>
  <div *ngIf="risks" class="risks">
    <clr-accordion [clrAccordionMultiPanel]="true" class="user-pref__accordion">
      <clr-accordion-panel>
        <clr-accordion-title>Risks ({{ ccyPair }})</clr-accordion-title>
        <clr-accordion-content *clrIfExpanded>
          <table ui-table>
            <thead>
              <tr>
                <th></th>
                <th *ngFor="let leg of risks.spotDelta; index as i">
                  Leg {{ i + 1 }}
                </th>
                <th>Total</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngIf="risks.brokerSpotDelta">
                <td>BS Spot Delta</td>
                <td *ngFor="let leg of risks.brokerSpotDelta">
                  {{ leg | safeNumber: '1.0-0' }}
                </td>
                <td>
                  {{ risks.brokerSpotDeltaTotal | safeNumber: '1.0-0' }}
                </td>
              </tr>
              <tr>
                <td>Smile Spot Delta</td>
                <td *ngFor="let leg of risks.spotDelta">
                  {{ leg | safeNumber: '1.0-0' }}
                </td>
                <td>
                  {{ risks.spotDeltaTotal | safeNumber: '1.0-0' }}
                </td>
              </tr>
              <tr *ngIf="risks.spotDeltaInPercent">
                <td>Smile Spot Delta %</td>
                <td *ngFor="let leg of risks.spotDeltaInPercent">
                  {{ leg * 100 | safeNumber: '1.4-4' }}%
                </td>
                <td>n/a</td>
              </tr>
              <tr *ngIf="risks.brokerGamma">
                <td>BS Gamma</td>
                <td *ngFor="let leg of risks.brokerGamma">
                  {{ leg | safeNumber: '1.0-0' }}
                </td>
                <td>
                  {{ risks.brokerGammaTotal | safeNumber: '1.0-0' }}
                </td>
              </tr>
              <tr *ngIf="risks.gamma">
                <td>Smile Gamma</td>
                <td *ngFor="let leg of risks.gamma">
                  {{ leg | safeNumber: '1.0-0' }}
                </td>
                <td>
                  {{ risks.gammaTotal | safeNumber: '1.0-0' }}
                </td>
              </tr>
            </tbody>
          </table>
        </clr-accordion-content>
      </clr-accordion-panel>
    </clr-accordion>
  </div>
</ng-template>

<!-- ALERTS -------------------------------------------------->

<ng-template #alertsTmpl>
  <!-- State -->
  <div class="alert alert-info alert-sm" role="alert" @fadeSlow>
    <div class="alert-items">
      <div class="alert-item static">
        <div class="alert-icon-wrapper">
          <cds-icon class="alert-icon" shape="info-circle"></cds-icon>
        </div>
        <span class="alert-text" title="{{ action }}">
          State: {{ actionMessage }}
          <ng-container *ngIf="action === 'ConfirmQuoteSubmit' && !isExpired">
            <ng-container *ngIf="expiresIn >= 0">
              Current quote expires in {{ expiresIn }}s.
            </ng-container>
            <ng-container *ngIf="expiresIn < 0">
              Current quote expired {{ -expiresIn }}s ago.
            </ng-container>
          </ng-container>
        </span>
      </div>
    </div>
  </div>

  <!-- bad vols -->
  <div
    class="alert alert-danger alert-sm"
    role="alert"
    @fadeSlow
    *ngIf="volsError"
  >
    <div class="alert-items">
      <div class="alert-item static">
        <div class="alert-icon-wrapper">
          <cds-icon class="alert-icon" shape="exclamation-circle"></cds-icon>
        </div>
        <span class="alert-text">
          Impossible to submit quote with vol bid {{ volsError.direction }} vol
          offer (leg {{ volsError.legIndex }})
        </span>
      </div>
    </div>
  </div>

  <!-- Current Owner -->
  <div
    class="alert alert-info alert-sm"
    role="alert"
    @fadeSlow
    *ngIf="quoteEvent.quote.owner && quoteEvent.quote.owner !== currentUser"
  >
    <div class="alert-items">
      <div class="alert-item static">
        <div class="alert-icon-wrapper">
          <cds-icon class="alert-icon" shape="info-circle"></cds-icon>
        </div>
        <span class="alert-text" title="{{ action }}">
          Quote owner is {{ quoteEvent.quote.owner }}
        </span>
      </div>
    </div>
  </div>

  <!-- Pickup error -->
  <div
    class="alert alert-warning alert-sm"
    role="alert"
    *ngIf="!isOwner && pickupErrorMessage"
    @fadeSlow
  >
    <div class="alert-items">
      <div class="alert-item static">
        <div class="alert-icon-wrapper">
          <cds-icon class="alert-icon" shape="exclamation-triangle"></cds-icon>
        </div>
        <span class="alert-text">
          Could not pick up RFQ&mdash;{{ pickupErrorMessage }}.
        </span>
      </div>
    </div>
  </div>

  <!-- Quote stale -->
  <div
    class="alert alert-danger alert-sm"
    role="alert"
    *ngIf="quoteInFlight && expiresIn < 0"
    @fadeSlow
  >
    <div class="alert-items">
      <div class="alert-item static">
        <div class="alert-icon-wrapper">
          <cds-icon class="alert-icon" shape="exclamation-circle"></cds-icon>
        </div>
        <span class="alert-text"> Quote is stale&mdash;please refresh it </span>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #ellipsisTmpl>
  <span class="quoting"><span>.</span><span>.</span><span>.</span></span>
</ng-template>

<ng-template #premiumInStyle [formGroup]="form">
  @if (premiumInStyleInfo.latestValue.bid != null) {
    <clr-input-container class="premium-in-style-bid">
      <input
        clrInput
        type="text"
        [ngClass]="{
          'manual-input': !premiumInStyleInfo.liveValue.bid,
          disabled: form.get('bidPremiumInStyle').disabled
        }"
        [@.disabled]="!premiumInStyleInfo.liveValue.bid"
        [@valueIncreaseDecrease]="premiumInStyleInfo.latestValue.bid"
        [inputValidator]="['positiveNumber']"
        formControlName="bidPremiumInStyle"
        (input)="changeInPremiumInStyle('bid', $any($event.target).value)"
        (blur)="blurPremiumInStyle('bid', $any($event.target).value)"
    /></clr-input-container>
    <div class="premium-in-style-bid-format premium-in-style-bid-format--input">
      <ng-container [ngSwitch]="premiumInStyleInfo.format.bid">
        <ng-container *ngSwitchCase="'percent'">%</ng-container>
        <ng-container *ngSwitchCase="'pips'">pips</ng-container>
        <ng-container *ngSwitchCase="'amount'">{{ premiumCCY }}</ng-container>
      </ng-container>
    </div>
  }

  @if (premiumInStyleInfo.latestValue.offer != null) {
    <clr-input-container class="premium-in-style-offer">
      <input
        clrInput
        type="text"
        [ngClass]="{
          'manual-input': !premiumInStyleInfo.liveValue.offer,
          disabled: form.get('offerPremiumInStyle').disabled
        }"
        [@.disabled]="!premiumInStyleInfo.liveValue.offer"
        [@valueIncreaseDecrease]="premiumInStyleInfo.latestValue.offer"
        [inputValidator]="['positiveNumber']"
        formControlName="offerPremiumInStyle"
        (input)="changeInPremiumInStyle('offer', $any($event.target).value)"
        (blur)="blurPremiumInStyle('offer', $any($event.target).value)"
    /></clr-input-container>

    <div
      class="premium-in-style-offer-format premium-in-style-offer-format--input"
    >
      <ng-container [ngSwitch]="premiumInStyleInfo.format.offer">
        <ng-container *ngSwitchCase="'percent'">%</ng-container>
        <ng-container *ngSwitchCase="'pips'">pips</ng-container>
        <ng-container *ngSwitchCase="'amount'">{{ premiumCCY }}</ng-container>
      </ng-container>
    </div>
  }
</ng-template>

<ng-template #CurrentlyQuotingPremiumInStyle>
  <ng-container *ngIf="isPremiumBasedVanillasWithSpotFeed">
    <ng-container *ngIf="premiumInStyleCurrentlyQuoted?.bid">
      <div class="premium-in-style-bid-label {{ bidActiveClass }}">
        <span></span><span></span><span></span>
      </div>

      <div class="premium-in-style-bid {{ bidActiveClass }}">
        {{ premiumInStyleCurrentlyQuoted.bid.value }}
      </div>

      <div class="premium-in-style-bid-format {{ bidActiveClass }}">
        <ng-container [ngSwitch]="premiumInStyleCurrentlyQuoted.bid.format">
          <ng-container *ngSwitchCase="'percent'">%</ng-container>
          <ng-container *ngSwitchCase="'pips'">pips</ng-container>
          <ng-container *ngSwitchCase="'amount'">{{ premiumCCY }}</ng-container>
        </ng-container>
      </div>
    </ng-container>

    <ng-container *ngIf="premiumInStyleCurrentlyQuoted?.offer">
      <div class="premium-in-style-offer-label {{ offerActiveClass }}">
        <span></span><span></span><span></span>
      </div>

      <div class="premium-in-style-offer {{ offerActiveClass }}">
        {{ premiumInStyleCurrentlyQuoted.offer.value }}
      </div>

      <div class="premium-in-style-offer-format {{ offerActiveClass }}">
        <ng-container [ngSwitch]="premiumInStyleCurrentlyQuoted.offer.format">
          <ng-container *ngSwitchCase="'percent'">%</ng-container>
          <ng-container *ngSwitchCase="'pips'">pips</ng-container>
          <ng-container *ngSwitchCase="'amount'">{{ premiumCCY }}</ng-container>
        </ng-container>
      </div>

      <div
        class="vendor-offer-premium-style-right-empty {{ offerActiveClass }}"
      >
        <span></span><span></span><span></span>
      </div>
    </ng-container>
  </ng-container>
</ng-template>
